import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomainService } from 'src/app/core/domain/domain.service';
import { WindowRef } from 'src/app/core/domain/window-ref';
import { ProfileService } from 'src/app/core/translation/profile.service';

@Component({
  selector: 'app-error',
  templateUrl: './error.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: true
})
export class ErrorComponent implements OnInit {

  private translationIndex = 'errorPage';
  private commonIndex = 'common';
  message: any;
  correlationId: string;
  date: string;
  method: string;
  status: string;
  info: string;
  homeUrl: string;

  constructor(private readonly pfs: ProfileService, private readonly route: ActivatedRoute, private readonly windowRef: WindowRef, private readonly domain: DomainService) { }

  ngOnInit(): void {
    this.message = { ...this.pfs.messages[this.commonIndex], ...this.pfs.messages[this.translationIndex] };
    this.homeUrl = this.domain.getHomeUrl(this.windowRef.getHostname());
    this.route.queryParams.subscribe(params => {
      const status = params['status'];
      this.method = params['method'];
      this.status = status;
      this.info = this.pfs.getErrorMessage(parseInt(status), this.message);
      this.correlationId = params['correlationId'];
      const timestamp = params['timestamp'];

      if (timestamp) {
        this.date = new Date(parseInt(timestamp)).toUTCString();
      }
    });
  }

}
